import { useDeferredValue, ViewTransition, type FC } from "react"

// oxlint-disable-next-line no-unassigned-import
import "./style.css"
import { Modal } from "./Modal"
import { closeModal, useModalStore } from "./store"

const open = (ref: HTMLDialogElement | null) => {
  ref?.showModal()
}

export const ModalRenderer: FC = () => {
  const modals = useModalStore()
  //To be able to use ViewTransition the modals needs to be wrapped in a useDeferredValue
  const deferredModals = useDeferredValue(modals)

  return (
    <>
      {deferredModals.map(({ uid, Component, props, width }) => (
        <ViewTransition
          key={uid}
          enter="fade-in-up"
          exit="fade-out-down"
        >
          <Modal.Root
            style={{ width }}
            onCancel={(e) => {
              e.preventDefault()
              closeModal(uid)
            }}
            onClose={() => {
              closeModal(uid)
            }}
            ref={open}
          >
            <Component
              {...props}
              onClose={(val: unknown) => {
                // oxlint-disable-next-line typescript/no-unsafe-call, typescript/no-unsafe-member-access
                props.onClose?.(val)
                closeModal(uid)
              }}
            />
          </Modal.Root>
        </ViewTransition>
      ))}
    </>
  )
}
